import { useSearchParams } from "react-router-dom";

export default function useUrlFilters() {
    const [params, setParams] = useSearchParams();

    const viewMode = params.get("view") || "current";

    const filters = {
        age: params.get("age") || "",
        gender: params.get("gender") || "",
        location: params.get("location") || "",
        description: params.get("description") || "",
        jobTitle: params.get("job_title") || "",
        company: params.get("company") || "",
        interest: params.get("interest") || "",
    };

    const setFilter = (key, value) => {
        const p = new URLSearchParams(params);
        if (value) p.set(key, value);
        else p.delete(key);
        setParams(p);
    };

    const clearFilters = () => {
        const p = new URLSearchParams(params);
        ["age", "gender", "location", "description", "job_title", "company", "interest"]
            .forEach((k) => p.delete(k));
        setParams(p);
    };

    return { params, setParams, viewMode, filters, setFilter, clearFilters };
}
